import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const OverlayContent = styled.div`
  background: white;
  padding: 32px 24px;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  min-width: 280px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: transform 0.2s ease;
`;

export const SelectedDate = styled.h2`
  text-align: center;
  font-size: 20px;
  margin: 0;
  color: #333;
`;

export const MenuHeader = styled.h4`
  text-align: center;
  font-size: 16px;
  margin: 0;
  font-weight: 500;
  color: #666;
`;

export const StyledSelect = styled.select`
  padding: 12px 14px;
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  color: #333;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #007bff;
    background-color: #fff;
  }
`;

export const Option = styled.option``;

export const OverlayButton = styled.button`
  margin-top: 10px;
  padding: 12px 16px;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s, transform 0.1s;

  &:hover {
    background-color: #0056b3;
  }

  &:active {
    transform: scale(0.98);
  }
`;

function StatusOverlay({ item, onClose, updateState }) {
  const axiosPrivate = useAxiosPrivate();
  const [status, setStatus] = useState("");
  const handleUnavailable = async (item, status) => {
    try {
      const payload = { id: item._id, status: status };

      const response =await axiosPrivate.post(
        "/logistics/profile",
        { payload },
        {
          headers: {
            "Context-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      if (response.status===200) {
        updateState(item._id, status)
      }
      //updateShiftInState(id)
    } catch (err) {
      console.error(err);
    }
  };
  const date = new Date(item.date);

  return (
    <Overlay className="overlay" onClick={()=>{onClose(false)}}>
      <OverlayContent
        className="overlay-content"
        onClick={(e) => e.stopPropagation()}
      >
        <SelectedDate>{date.toDateString()}</SelectedDate>
        <MenuHeader>Välj Status:</MenuHeader>
        <StyledSelect
          onChange={(e) => {
            setStatus(e.target.value);
            handleUnavailable(item, e.target.value);
            onClose(false)
          }}
          defaultValue=""
        >
          <Option value="" disabled>
            Välj alternativ...
          </Option>
          <Option key={"option1"} value={"T"}>
            Tillgänglig
          </Option>
          <Option key={"option2"} value={"T(fm)"}>
            Tillgänglig på förmiddagen
          </Option>
          <Option key={"option3"} value={"T(em)"}>
           Tillgänglig på eftermiddagen 
          </Option>
          <Option key={"option4"} value={"Ej T"}>
           {"Ej Tillgänglig"}
          </Option>
        </StyledSelect>
        <OverlayButton
          onClick={() => {
            onClose(false);
          }}
        >
          Stänga
        </OverlayButton>
      </OverlayContent>
    </Overlay>
  );
}

export default StatusOverlay;
